import Head from "next/head";

const MetaTags = ({
  title,
  keywords,
  description,
  image,
  robots,
  maxSnippet,
  url,
  type = "website",
}) => {
  const robotsContent = [robots, maxSnippet ? `max-snippet:${maxSnippet}` : null]
    .filter(Boolean)
    .join(", ");

  const baseUrl =
    typeof window !== "undefined"
      ? window.location.origin
      : process.env.NEXT_PUBLIC_SITE_URL || "";
  const canonicalUrl =
    url || (typeof window !== "undefined" ? window.location.href : undefined);

  return (
    <Head>
      <meta httpEquiv="content-type" content="text/html; charset=UTF-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {robotsContent && <meta name="robots" content={robotsContent} />}
      {title && (
        <>
          <meta property="og:site_name" content={title} />
          <title>{title}</title>
          <meta property="og:title" content={title} />
          <meta name="twitter:title" content={title} />
        </>
      )}
      {description && (
        <>
          <meta name="description" content={description} />
          <meta property="og:description" content={description} />
          <meta name="twitter:description" content={description} />
        </>
      )}
      {image && (
        <>
          <meta property="og:image" content={image} />
          <meta name="twitter:image" content={image} />
        </>
      )}
      {keywords && <meta name="keywords" content={keywords} />}
      <meta property="og:type" content={type} />
      <meta name="twitter:card" content="summary_large_image" />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
    </Head>
  );
};

export default MetaTags;
